import api from '../utils/api';
import { GET_HOTLINE_CATEGORIES } from '../utils/types';


export const getHotlineCategories = ( ...extra) => ({
    type: GET_HOTLINE_CATEGORIES,
    payload: api.get(`/hotlinecategories`, null,...extra)
});
